import React, { useEffect, useState, useMemo } from "react";
import swal from "sweetalert";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import Header from "../../layout/Header";
import {
  generateQRCode,
  getQRTemplate,
  getQRTemplateData,
  updateQRTemplate,
} from "../../../services/services";
import ExcelJS from "exceljs";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import { decrypt } from "../../../utils/encodingdecoding";
import { clearSetting } from "../../../actions/setting";
import { connect } from "react-redux";
import {} from "../../../utils";
import { getColumns } from "./column";
import { getAllProfile, getPromotion } from "../../../services/auth";
import GenerateQRModal from "./GeneratQRModal";
import { getDisplayDate } from "../../../utils/helper";
import Paginated from "../../partial/Paginated";

const QRCodeTemplate = ({ clearSetting }) => {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [originalData, setOriginalData] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedProduct, setSelectedProduct] = useState("");
  const [productList, setProductList] = useState([]);

  const [showQRModal, setShowQRModal] = useState(false);
  const [selectedQRData, setSelectedQRData] = useState(null);

  const columns = useMemo(() => getColumns(), []);

  useEffect(() => {
    fetchData();
  }, []);

  const openGenerateModal = (code, val, portal, type) => {
    setSelectedQRData({
      code,
      val,
      portal,
      type,
    });

    setShowQRModal(true);
  };

  const confirmGenerateQR = async () => {
    if (!selectedQRData) return;

    await handleClick(
      selectedQRData.code,
      selectedQRData.val,
      selectedQRData.portal,
      selectedQRData.type,
    );

    setShowQRModal(false);
  };

  const fetchData = async () => {
    try {
      setLoader(true);

      const Id = decrypt(localStorage.getItem("Id"));
      const tokenRes = JSON.parse(localStorage.getItem("token_gen"));

      const response = await getQRTemplate(tokenRes.access_token);

      const prodRes = await getPromotion(tokenRes?.access_token, Id);

      setProductList(prodRes?.data || []);

      if (response.message === "Record Created Successfully.") {
        if (Array.isArray(response?.data) && response?.data?.length > 0) {
          await clearSetting();

          const res = await getAllProfile(
            tokenRes?.access_token,
            decrypt(localStorage.getItem("merchantcode")),
          );

          const templateData = response.data?.map((val) => {
            val.batchNo = val?.others?.subCategory;

            val.variant = val?.others?.variant;

            val.issuedate = getDisplayDate(val.createdDate);

            val.generate =
              Number(val.quantity) === 0 ? (
                <span
                  title="Please edit the template and add quantity before generating QR codes."
                  style={{
                    cursor: "not-allowed",
                    opacity: 0.5,
                    pointerEvents: "auto",
                  }}
                >
                  <i className="fa-solid fa-qrcode fa-lg text-muted"></i>
                </span>
              ) : val.status?.toLowerCase() === "inactive" ? (
                <span
                  title="This template is inactive. Please activate it to generate a QR code."
                  style={{
                    cursor: "not-allowed",
                    opacity: 0.5,
                    pointerEvents: "auto",
                  }}
                >
                  <i className="fa-solid fa-qrcode fa-lg text-muted"></i>
                </span>
              ) : (
                <Link
                  to=""
                  title="Generate QR"
                  onClick={() =>
                    openGenerateModal(val.code, val, res?.rewardportal, "csv")
                  }
                >
                  <i className="fa-solid fa-qrcode fa-lg"></i>
                </Link>
              );

            val.action = (
              <>
                <Link
                  to=""
                  title="Download CSV"
                  onClick={() =>
                    handleClick(val.code, val, res?.rewardportal, "csv")
                  }
                  className="text-success me-3"
                >
                  <i className="fa-solid fa-file-csv fa-lg"></i>
                </Link>

                <Link
                  to=""
                  title="Download ZIP"
                  onClick={() =>
                    handleClick(val.code, val, res?.rewardportal, "zip")
                  }
                  className="text-warning"
                >
                  <i className="fa-solid fa-file-zipper fa-lg"></i>
                </Link>
              </>
            );

            val.edit = (
              <Link to={`/qr-code-template?code=${val.code}`}>
                <i className="fa-solid fa-edit"></i>
              </Link>
            );

            val.totalqrcodecount = <>{val.totalqrcodecount}</>;

            return val;
          });

          setData(templateData ? [...templateData].reverse() : []);

          setOriginalData(templateData || []);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const handleClick = async (code, val, portal, type) => {
    const email = localStorage.getItem("email");

    try {
      const url = portal?.includes("https://")
        ? `${portal}`
        : `${portal}.paybypoint.com/qr-code-details`;

      setLoader(true);

      const tokenRes = JSON.parse(localStorage.getItem("token_gen"));

      let body;

      body = {
        templatecode: code,
        url: url,
      };

      const response = await generateQRCode(tokenRes.access_token, body);

      if (response.message === "Record Created Successfully.") {
        const {
          action,
          valueType,
          createdBy,
          createdDate,
          code,
          merchantId,
          redemptionlimitcount,
          redemptionlimittype,
          status,
          totalqrcodecount,
          updatedBy,
          updatedDate,
          quantity,
          others,
          ...rest
        } = val;

        const qrcodes = response.data.qrcodes.map((item) => ({
          ...item,
          ...rest,
        }));

        if (type === "csv") {
          generateExcel(qrcodes);
        }

        if (type === "zip") {
          await generateZip(qrcodes);
        }

        await fetchData();

        swal({
          position: "center",
          icon: "success",
          title: "QR code created successfully",
          showConfirmButton: false,
          timer: 5000,
        });
      } else {
        swal({
          title: "Oops!",
          text: response.message,
          icon: "error",
          button: "oh no!",
          timer: 5000,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const generateExcel = async (qrcodeData) => {
    try {
      const workbook = new ExcelJS.Workbook();

      const worksheet = workbook.addWorksheet("QR Code Data");

      const hasQrCode = qrcodeData.some(
        (item) => item.qrcode && item.qrcode.startsWith("data:image"),
      );

      const allKeys = Object.keys(qrcodeData[0]);

      const reorderedKeys = hasQrCode
        ? [
            "code",
            "qrcode",
            ...allKeys.filter((key) => key !== "code" && key !== "qrcode"),
          ]
        : [
            "code",
            ...allKeys.filter((key) => key !== "code" && key !== "qrcode"),
          ];

      worksheet.columns = reorderedKeys.map((key) => ({
        header: key === "productName" ? "product description" : key,
        key,
        width: key === "qrcode" ? 34 : 30,
      }));

      qrcodeData.forEach((row, index) => {
        const rowIndex = index + 2;

        const newRow = {};

        reorderedKeys.forEach((key) => {
          if (key !== "qrcode") {
            newRow[key] = Array.isArray(row[key])
              ? row[key].join(", ")
              : row[key];
          }
        });

        worksheet.addRow(newRow);

        if (hasQrCode) {
          worksheet.getRow(rowIndex).height = 135;
        }

        if (hasQrCode && row.qrcode && row.qrcode.startsWith("data:image")) {
          const imageId = workbook.addImage({
            base64: row.qrcode,
            extension: "png",
          });

          const qrCodeColIndex = reorderedKeys.indexOf("qrcode");

          worksheet.addImage(imageId, {
            tl: {
              col: qrCodeColIndex + 0.15,
              row: rowIndex - 1,
            },
            ext: {
              width: 170,
              height: 170,
            },
            editAs: "oneCell",
          });
        }
      });

      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "QR_Code_Data.xlsx");
    } catch (error) {
      console.error("Error generating Excel:", error);
    }
  };

  const generateZip = async (qrcodes) => {
    const zip = new JSZip();

    const folder = zip.folder("qrcodes");

    for (const item of qrcodes) {
      const { code, qrcode } = item;

      if (qrcode.startsWith("data:image")) {
        const base64Data = qrcode.split(",")[1];

        folder.file(`${code}.png`, base64Data, {
          base64: true,
        });
      }
    }

    const zipBlob = await zip.generateAsync({
      type: "blob",
    });

    saveAs(zipBlob, "qrcodes.zip");
  };

  const handleSuperonFilter = (type, value) => {
    let status = selectedStatus;
    let product = selectedProduct;

    if (type === "status") {
      status = value;
      setSelectedStatus(value);
    }

    if (type === "product") {
      product = value;
      setSelectedProduct(value);
    }

    let filteredData = originalData;

    if (status) {
      filteredData = filteredData?.filter((item) => item.status === status);
    }

    if (product) {
      filteredData = filteredData?.filter(
        (item) => item.productName === product,
      );
    }

    setData(filteredData);
  };

  return (
    <>
      <Header name={"QR Code Template"} />

      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}

      <div className="dashboard__content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
              <div className="dashboard__heading">
                <div className="dashboard__headingLeft">
                  <div className="dashboard__headingContent">
                    <Link to={"/qr-code"}>
                      <Button id="voucher" className="btn btn-primary btn-lg">
                        Generate QR Code Template
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="dashboard__customersCard">
              <div className="dashboard__header">
                <div className="dashboard__left">
                  <h4 id="voucher_details">QR Code Template Details</h4>
                </div>
              </div>

              <div className="dashboard__body">
                <Paginated
                  data={data || []}
                  originalData={originalData}
                  columns={columns}
                  selectedStatus={selectedStatus}
                  setSelectedStatus={setSelectedStatus}
                  selectedProduct={selectedProduct}
                  setSelectedProduct={setSelectedProduct}
                  handleSuperonFilter={handleSuperonFilter}
                  templateList={productList}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <GenerateQRModal
        show={showQRModal}
        close={() => setShowQRModal(false)}
        onConfirm={confirmGenerateQR}
        loading={loader}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  Setting: state.Setting,
});

const mapDispatchToProps = {
  clearSetting,
};

export default connect(mapStateToProps, mapDispatchToProps)(QRCodeTemplate);
